import { render, staticRenderFns } from "./RedirectionFacture.vue?vue&type=template&id=27a1b75b"
import script from "./RedirectionFacture.vue?vue&type=script&lang=js"
export * from "./RedirectionFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports